import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';

export const CheckboxFieldParamsSchema = FieldSchema.extend({
  description: z.string().optional(),
  syncEvents: z.boolean().optional(),
});

export type TCheckboxFieldParams = z.infer<typeof CheckboxFieldParamsSchema>;

export const CHECKBOX_FIELD_ELEMENT_TYPE = 'checkboxfield' as const;

export const CheckboxFieldElementType = z.literal(CHECKBOX_FIELD_ELEMENT_TYPE);

export type TCheckboxFieldParamsSchema = z.infer<typeof CheckboxFieldParamsSchema>;

export const CheckboxFieldElementSchema = InitialUIElement.extend({
  element: CheckboxFieldElementType,
  params: CheckboxFieldParamsSchema,
  valueDestination: z.string(),
});
